var Vue = require('vue');
var sw  = require('js/lib/sw');
var _ = require('underscore');
var axios = require('axios');
var VueAxios = require('vue-axios');

Vue.use(VueAxios,axios);

var mountedFragment = function mountedFragment() {
  this.$nextTick(function () {
    var _this = this;
    var $el = $(this.$el);
    sw.trigger('sw-fragment-loaded', $el);
    // Listen to changes in the selectric dropdown and pass it to the the Vue object method
    $el.on('selectric-change', function(e, el) {
      _this.dispatchInputEvent(el.value,el.options[el.selectedIndex].text);
    });
  });
};

module.exports = function ($fragment) {
  $fragment.swFindWithSelf("[data-sw-manage-permissions]").each(function () {

    var roles = _.chain(sw.data.roles)
      .groupBy('role_category_name')
      .map(function (value, key) {
        return {
          role_category_name: key,
          roles: value
        };
      }).value();

    new Vue({
      el: this,
      data: {
        roles: roles,
        permissions: sw.data.permissions,
        toAddPermissions: [],
        toRemovePermissions: [],
        selectedRole: {
          id: 0,
          name: ''
        },
        selectedPermissions: {},
        isBusy: false
      },
      mounted: mountedFragment,
      methods: {
        dispatchInputEvent: function dispatchInputEvent(value, text) {
          this.selectedRole.id = value;
          this.selectedRole.name = text;
          this.getPermissionsByRoleId(value);
        },
        getPermissionsByRoleId: function(roleId){
          var self = this;
          self.isBusy = true;
          this.$http.get('/access-control/permissions?roleId=' + roleId)
            .then(function (response) {
              self.selectedPermissions =  response.data.permissions;
              self.isBusy = false;
            }).catch(function(error){
            sw.notifications.error(error);
            self.isBusy = false;
          });
        },
        addPermissionsToRole: function() {
          var self = this;
          self.isBusy = true;
          var alreadyAddedPermissionIds = _.map(this.selectedPermissions, function(permission) { return permission.permission_id });
          var permissionsToAdd = _.difference(self.toAddPermissions, alreadyAddedPermissionIds);
          var bodyData = new FormData();
          bodyData.set('roleId', self.selectedRole.id);
          bodyData.set('permissions', permissionsToAdd);
          var requestHeaders = {
            headers: {'Content-Type': 'multipart/form-data'}
          };
          this.$http.post('/access-control/permissions/add',bodyData, requestHeaders)
            .then(function(response){
              self.selectedPermissions = _.union(self.selectedPermissions,response.data.permissions);
              self.isBusy = false;
            }).catch(function(error){
              sw.notifications.error(error);
              self.isBusy = true;
          });
        },
        removePermissionsFromRole: function() {
          var self = this;
          self.isBusy = true;
          var bodyData = new FormData();
          bodyData.set('roleId', self.selectedRole.id);
          bodyData.set('permissions', self.toRemovePermissions);
          var requestHeaders = {
            headers: {'Content-Type': 'multipart/form-data'}
          };
          this.$http.post('/access-control/permissions/remove',bodyData, requestHeaders)
            .then(function(response){
              self.selectedPermissions = response.data.permissions;
              self.isBusy = false;
            }).catch(function(error){
            sw.notifications.error(error);
            self.isBusy = true;
          });
        }
      }
    });
  });
}

